"use strict";
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/rxjs/util/isScheduler.js
// module id = ../../../../rxjs/util/isScheduler.js
// module chunks = 4